import { render, staticRenderFns } from "./HelpArticlesSearchResultsComponent.vue?vue&type=template&id=39c1f7d3&scoped=true&"
import script from "./HelpArticlesSearchResultsComponent.vue?vue&type=script&lang=js&"
export * from "./HelpArticlesSearchResultsComponent.vue?vue&type=script&lang=js&"
import style0 from "./HelpArticlesSearchResultsComponent.vue?vue&type=style&index=0&id=39c1f7d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1f7d3",
  null
  
)

export default component.exports